import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const getAllPreorders = async (
  page: number,
  pageSize: number,
  startDate?: string | null,
  endDate?: string | null,
  sortOrder?: string,
  searchQuery?: string,
  status?: string | null
) => {
  try {
    const params: any = {
      page,
      pageSize,
      orgId: getApiOrganizationId(),
    };
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    if (sortOrder) params.sortOrder = sortOrder.toUpperCase();
    if (searchQuery) {
      params.searchQuery = searchQuery;
    }
    if (status) {
      params.status = status;
    }

    const response = await api.get("/prebooking", {
      params,
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Unexpected error fetching all preorders:", error);
    throw new Error("Failed to get all preorders.");
  }
};

export const getPreordersByCustomerEmail = async (
  emailId: string,
  page: number,
  pageSize: number,
  sortOrder?: string,
  searchQuery?: string
) => {
  try {
    const params: any = { page, pageSize };
    if (sortOrder) params.sortOrder = sortOrder.toUpperCase();
    if (searchQuery) {
      params.searchQuery = searchQuery;
    }
    const response = await api.get(`/prebooking-by-customer/${emailId}`, {
      params,
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Unexpected error fetching preorders for customer ${emailId}:`,
      error
    );
    throw new Error("Failed to get preorders for customer.");
  }
};

export const updatePrebookingStatus = async (data: {
  id: string;
  status: string;
}) => {
  try {
    const response = await api.put(
      `/prebooking/${data.id}`,
      {
        status: data.status,
      },
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update prebooking status:", error);
    throw error;
  }
};
